import { UUID } from '@macs-frontend/core/utils/uuid';
import { BaseEntity } from './base-entity.model';
import { BaseTaskGroup } from './task-group.model';
import { TaskRole } from '@macs-frontend/features/shared/models/task-role.model';

export interface BaseTask extends BaseEntity {
  status: TaskStatuses;
  description: string;
  defaultBillable: boolean;
  defaultHourlyRate: number;
  defaultTask: boolean;
  name?: string;
  groupByType?: string;
}

export interface Task extends BaseTask {
  taskGroups: BaseTaskGroup[];
  taskRole?: TaskRole | null;
}

export enum TaskStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
